<template>
	<svg
		class="dash-line"
		width="100%"
		height="1"
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
	>
		<rect
			width="100%"
			height="100%"
			fill="none"
			:stroke="stroke"
			stroke-width="3"
			stroke-dasharray="4, 14"
			stroke-linecap="square"
			:style="{ 'stroke-opacity': strokeOpacity }"
		></rect>
	</svg>
</template>

<script>
export default {
	name: 'DashedLine',

	props: {
		lightTheme: {
			type: Boolean,
			default: false
		},

		opacity: {
			type: String,
			default: ''
		}
	},

	computed: {
		stroke() {
			return this.lightTheme ? '#fff' : '#000'
		},

		strokeOpacity() {
			return this.opacity ? this.opacity : '0.25'
		}
	}
}
</script>

<style lang="scss">
.dash-line {
	display: block;

	rect {
		stroke-opacity: 0.25;
		stroke-dashoffset: 16;
	}
}
</style>
